import { render, staticRenderFns } from "./VoiceExport.vue?vue&type=template&id=536a3dbc&"
import script from "./VoiceExport.vue?vue&type=script&lang=js&"
export * from "./VoiceExport.vue?vue&type=script&lang=js&"
import style0 from "./VoiceExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports